<template>
  <div class="recall-layout">
    <div v-wechat-title="'最强蜗牛'"></div>

    <!-- 子页面内容 -->
    <router-view :downloadApp="downloadApp" />

    <!-- tab 切换按钮 -->
    <div v-if="showTabs" class="section-tabs">
      <div class="tabs-box">
        <div v-for="(tab, index) in tabs" :key="index" class="tab-item" :class="['tab-' + tab.id, { active: isActive(tab.path) }]" @click="goTo(tab)"></div>
      </div>
    </div>
    <!-- 微信下载 -->
    <div class="wechat_download_wrap popup_wrap" v-show="wxLoadShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active" :duration="{ enter: 1000 }">
        <div class="wx_download_wrap_content" @click="wxLoadShow = false"></div>
      </transition>
      <div class="close-bg" v-if="wxLoadShow" @click="wxLoadShow = false"></div>
    </div>
  </div>
</template>

<script>
import { getTimeStamp, buriedLogger, wechatBrowser, analysisParams } from "@/utils/utils";
export default {
  name: 'Layout',
  components: {},
  data() {
    return {
      tabs: [
        { id:'1', label: '周年服福利', path: 'anniversary' },
        { id:'2', label: '组队有奖', path: 'enter' },
        { id:'3', label: '更多资讯', path: 'info' }
      ],
      logger: null,
      wxLoadShow: false,
      links: {
        1: {
          and: 'https://download4.qcplay.com/apk-v2/qc-kol-1167693.apk',
          ios: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1167641&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188',
        },
        2: {
          and: 'https://download4.qcplay.com/apk-v2/qc-kol-1167694.apk',
          ios: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1167642&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188',
        },
        3: {
          and: 'https://download4.qcplay.com/apk-v2/qc-kol-1167695.apk',
          ios: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1167643&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188',
        },
        4: {
          and: 'https://download4.qcplay.com/apk-v2/qc-kol-1167696.apk',
          ios: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1167644&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188',
        },
        5: {
          and: 'https://download4.qcplay.com/apk-v2/qc-kol-1167697.apk',
          ios: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1167645&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188',
        },
        6: {
          and: 'https://download4.qcplay.com/apk-v2/qc-kol-1167698.apk',
          ios: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1167646&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188',
        },
        7: {
          and: 'https://download4.qcplay.com/apk-v2/qc-kol-1167699.apk',
          ios: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1167647&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188',
        },
        8: {
          and: 'https://download4.qcplay.com/apk-v2/qc-kol-1167700.apk',
          ios: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1167648&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188',
        },
        9: {
          and: 'https://download4.qcplay.com/apk-v2/qc-kol-1167701.apk',
          ios: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1167649&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188',
        },
        10: {
          and: 'https://download4.qcplay.com/apk-v2/qc-kol-1167702.apk',
          ios: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1167650&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188',
        },
        11: {
          and: 'https://download4.qcplay.com/apk-v2/qc-kol-1167703.apk',
          ios: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1167651&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188',
        },
        12: {
          and: 'https://download4.qcplay.com/apk-v2/qc-kol-1167704.apk',
          ios: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1167652&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188',
        },
        13: {
          and: 'https://download4.qcplay.com/apk-v2/qc-kol-1167705.apk',
          ios: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1167653&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188',
        },
      },
      kol: '',
      currentTab: '',
    };
  },
  created() {
    if (!this.isMobile() && !window.location.href.includes('pc')) {
      window.location.href = `https://h5.qingcigame.com/snail/recall/pc${getTimeStamp()}`;
      return;
    }

    const bl = buriedLogger('snail', '五周年庆_layout');
    this.logger = bl;
    // setTimeout(() => {
    //   this.logger.sum('五周年庆');
    // }, 200)

    const params = analysisParams(window.location.href);
    const { kol } = params;
    this.kol = kol;
  },
  computed: {
    showTabs() {
      const currentPath = this.$route.path;
      return this.tabs.some(tab => currentPath.includes(tab.path));
    }
  },
  methods: {
    isMobile() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /android|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i.test(
        userAgent
      );
    },
    isActive(tabPath) {
      return this.$route.path.includes(`/recall/${tabPath}`);
    },
    goTo(tab) {
      if (!this.isActive(tab.path)) {
        this.logger.sum('五周年庆_' + tab.label);
        this.$router.push(`/recall/${tab.path}`);
      }
    },
    downloadApp(callback) {
      const isWechat = wechatBrowser()
      if (isWechat) {
        callback ? callback() : this.wxLoadShow = true
      } else {
        const linkObj = this.links[this.kol] || {
          and: 'https://download4.qcplay.com/apk-v2/qc-kol-1164305.apk',
          ios: 'https://apps.apple.com/cn/app/%E6%9C%80%E5%BC%BA%E8%9C%97%E7%89%9B/id1507966188',
        }
        const isIOS = navigator.userAgent.match(/(iPhone|iPod|ios)/i)
        const targetLink = isIOS ? linkObj.ios : linkObj.and

        if (targetLink) {
          setTimeout(() => {
            window.location.href = targetLink
          }, 200)
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import url('~@/assets/css/active.less');

.section-tabs {
  position: fixed;
  bottom: 0;
  left: 50%;
  width: 750px;
  height: 118px;
  margin-left: -375px;
  display: flex;
  justify-content: space-between;
  background: url(https://download4.qcplay.com/h5-images/active/snail/recall/bottom_nav_bg.png)
    no-repeat;
  background-size: 100% 100%;
  z-index: 98;

  .tabs-box {
    width: 712px;
    height: 96px;
    margin: 15px auto 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .tab-item {
      width: 215px;
      height: 80px;
      cursor: pointer;
    }

    .tab-1 {
      background: url(https://download4.qcplay.com/h5-images/active/snail/recall/nav_01_01.png) no-repeat;
      background-size: 100% 100%;
    }

    .tab-2 {
      background: url(https://download4.qcplay.com/h5-images/active/snail/recall/nav_02_01.png) no-repeat;
      background-size: 100% 100%;
    }

    .tab-3 {
      background: url(https://download4.qcplay.com/h5-images/active/snail/recall/nav_03_01.png) no-repeat;
      background-size: 100% 100%;
    }

    .tab-item.active {
      width: 248px;
      height: 96px;
    }
    .tab-1.active {
      background: url(https://download4.qcplay.com/h5-images/active/snail/recall/nav_01_02.png) no-repeat;
      background-size: 100% 100%;
    }

    .tab-2.active {
      background: url(https://download4.qcplay.com/h5-images/active/snail/recall/nav_02_02.png) no-repeat;
      background-size: 100% 100%;
    }

    .tab-3.active {
      background: url(https://download4.qcplay.com/h5-images/active/snail/recall/nav_03_02.png) no-repeat;
      background-size: 100% 100%;
    }
  }
}
.wechat_download_wrap {
  .wx_download_wrap_content {
    background: url(https://download4.qcplay.com/h5-images/active/snail/recall/download_bg.png)
      no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/snail/recall/Layout.vue